export default __webpack_public_path__ + "static/media/shadowlion.024628d3.jpg";